import { Link } from "react-router";
import { getMimeTypeIcon } from "@app/util/helpers";
import { FeedAttachment } from "@pages/Article/utils/types";

type ArticleAttachmentsProps = {
  className?: string;
  attachments?: FeedAttachment[];
};

const ArticleAttachments = ({
  className,
  attachments,
}: ArticleAttachmentsProps): React.ReactElement => {
  return (
    <>
      {attachments?.length ? (
        <div data-testid="article-attachments-component" className={className}>
          {attachments.map((attachment, index) => {
            const iconPath = getMimeTypeIcon(attachment.title);
            const attachmentLink = attachment.href;

            if (!attachmentLink) return null;

            return (
              <div key={index} className="border-b border-gray-250 py-4">
                {iconPath ? (
                  <span
                    className="inline-block h-4 w-4 bg-center bg-no-repeat align-middle"
                    style={{ backgroundImage: `url(${iconPath})` }}
                  ></span>
                ) : null}

                <Link
                  className="file pl-2 font-poppins text-base font-normal hover:!text-gray-850 hover:underline"
                  to={attachmentLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {attachment.title}
                </Link>
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default ArticleAttachments;
